import React, { useEffect, useState } from "react";
import {
  Card,
  Table,
  Button,
  Row,
  Col,
  Form,
  Image,
  Pagination,
  Badge,
} from "@themesberg/react-bootstrap";
import { Link, useHistory } from "react-router-dom";
import api from "../../utils/api";
import Swal from "sweetalert2";
import defaultIcon from "./../../assets/img/brand/logo2.png";

export default function NewUserList() {
  /* const history = useHistory();
  const [items, setItems] = useState([]);
  const [page, setPage] = useState(1);
  const [perPage, setPerPage] = useState(10);
  const [total, setTotal] = useState(0);
  const [search, setSearch] = useState("");
  const [loading, setLoading] = useState(false); */
  const history = useHistory();
  const [items, setItems] = useState([]);
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [perPage, setPerPage] = useState(20);
  const [search, setSearch] = useState("");

  const fetchData = async () => {
    setLoading(true);
    try {
      const { data } = await api.get(`/users`, {
        params: { page, perPage, search },
      });
      if (!data.error) {
        setItems(data.data);
        setTotal(data.total);
      }
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, [page, perPage]);

  const blockUser = async (id) => {
    try {
      const { data } = await api.post(`/users/${id}/block`);
      return data;
    } catch (e) {
      return { error: true, message: e?.response?.data?.message || e.message };
    }
  };

  const unblockUser = async (id) => {
    try {
      const { data } = await api.post(`/users/${id}/unblock`);
      return data;
    } catch (e) {
      return { error: true, message: e?.response?.data?.message || e.message };
    }
  };

  const handleBlock = async (user) => {
    const result = await Swal.fire({
      title: `Block ${user.name}?`,
      text: "The user will be blocked and unable to interact.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#ef4444",
      cancelButtonColor: "#3b82f6",
      confirmButtonText: "Yes, Block",
      heightAuto: false,
    });

    if (!result.isConfirmed) return;

    const response = await blockUser(user.id);
    if (!response.error) {
      Swal.fire({
        icon: "success",
        title: "Blocked!",
        text: response.message,
        timer: 1500,
        showConfirmButton: false,
      });
      fetchData();
    } else {
      Swal.fire({
        icon: "error",
        title: "Block Failed",
        text: response.message,
      });
    }
  };

  const handleUnblock = async (user) => {
    const result = await Swal.fire({
      title: `Unblock ${user.name}?`,
      text: "The user will be unblocked and regain access.",
      icon: "info",
      showCancelButton: true,
      confirmButtonColor: "#10b981",
      cancelButtonColor: "#3b82f6",
      confirmButtonText: "Yes, Unblock",
      heightAuto: false,
    });

    if (!result.isConfirmed) return;

    const response = await unblockUser(user.id);
    if (!response.error) {
      Swal.fire({
        icon: "success",
        title: "Unblocked!",
        text: response.message,
        timer: 1500,
        showConfirmButton: false,
      });
      fetchData();
    } else {
      Swal.fire({
        icon: "error",
        title: "Unblock Failed",
        text: response.message,
      });
    }
  };

  const handleDelete = async (id) => {
    const { data } = await api.get(`/users/${id}`);
    const n = data.data || {};
    const result = await Swal.fire({
      title: `Delete ${n.name}?`,
      text: "This action cannot be undone.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it",
      cancelButtonText: "Cancel",
      heightAuto: false,
    });
    if (!result.isConfirmed) return;
    try {
      await api.delete(`/users/${id}`);
      await Swal.fire({
        title: "Deleted!",
        text: "User was deleted.",
        icon: "success",
        timer: 1500,
        showConfirmButton: false,
        heightAuto: false,
      });
      fetchData();
    } catch (e) {
      await Swal.fire({
        title: "Error",
        text: e?.response?.data?.message || e.message || "Failed to delete",
        icon: "error",
        heightAuto: false,
      });
    }
  };

  const totalPages = Math.ceil(total / perPage) || 1;

  const verifyUser = async (id) => {
    try {
      const { data } = await api.post(`/users/${id}/verify`);
      return data;
    } catch (e) {
      return { error: true, message: e?.response?.data?.message || e.message };
    }
  };

  const handleReject = async (user) => {
    const result = await Swal.fire({
      title: `Are you sure you want to reject ${user.name}?`,
      text: "The user will be rejected and will not gain access.",
      icon: "info",
      showCancelButton: true,
      confirmButtonColor: "#10b981",
      cancelButtonColor: "#3b82f6",
      confirmButtonText: "Yes, Reject",
      heightAuto: false,
    });

    if (!result.isConfirmed) return;

    const { data } = await api.post(`/users/${user.id}/reject`);
    if (!data.error) {
      Swal.fire({
        icon: "success",
        title: "Rejected!",
        text: data.message,
        timer: 1500,
        showConfirmButton: false,
      });
      fetchData();
    } else {
      Swal.fire({
        icon: "error",
        title: "Rejection Failed",
        text: data.message,
      });
    }
  };

  const handleVerification = async (user) => {
    const result = await Swal.fire({
      title: `Are you sure you want to verify ${user.name}?`,
      text: "The user will be verified and gain access.",
      icon: "info",
      showCancelButton: true,
      confirmButtonColor: "#10b981",
      cancelButtonColor: "#3b82f6",
      confirmButtonText: "Yes, Verify",
      heightAuto: false,
    });

    if (!result.isConfirmed) return;

    const response = await verifyUser(user.id);
    if (!response.error) {
      Swal.fire({
        icon: "success",
        title: "Verified!",
        text: response.message,
        timer: 1500,
        showConfirmButton: false,
      });
      fetchData();
    } else {
      Swal.fire({
        icon: "error",
        title: "Verification Failed",
        text: response.message,
      });
    }
  };
  return (
    <Card className="shadow-sm">
      <Card.Header>
        <Row className="align-items-center">
          <Col>
            <h5 className="mb-0">User List</h5>
          </Col>
          <Col className="text-end">
            {/*  <Button as={Link} to={`/news/new`} variant="primary">Create</Button> */}
          </Col>
        </Row>
        <Row className="mt-3">
          <Col md={6}>
            <Form.Control
              placeholder="Search..."
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />
          </Col>
          <Col md={2}>
            <Button
              variant="outline-secondary"
              onClick={() => {
                setPage(1);
                fetchData();
              }}
            >
              Search
            </Button>
          </Col>
        </Row>
      </Card.Header>
      <Card.Body>
        <Table responsive hover className="align-items-center">
          <thead>
            <tr>
              <th>#</th>
              <th>Image</th>
              <th>Name</th>
              <th>Email</th>
              <th>Age</th>
              <th>Gender</th>
              <th>Phone</th>
              <th>Marital Status</th>
              <th>Matches Count</th>
              <th>Verification Status</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {items.map((n, index) => (
              <tr key={n.id}>
                <td>{(page - 1) * perPage + index + 1}</td>
                {/* <td>{n.uri ? <Image src={n.uri} width={50} height={'auto'} rounded /> : '-'}</td> */}
                <td>
                  <Image
                    src={n.uri || defaultIcon}
                    width={50}
                    height={"auto"}
                    rounded
                    onError={(e) => {
                      e.target.onerror = null;
                      e.target.src = defaultIcon;
                    }}
                  />
                </td>
                <td>{n.name}</td>
                <td>{n.email || "-"}</td>
                <td>{n.age || "-"}</td>
                <td>{n.gender || "-"}</td>
                <td>{n.phone || "-"}</td>
                {/* <td>{n.location || '-'}</td> */}
                <td>{n.martial_status || "-"}</td>
                <td>{n.matchesCount || 0}</td>
                <td>
                  {n.is_verified == 0 && <Badge bg="warning">Not Verified</Badge>}
                  {n.is_verified == 2 && <Badge bg="danger">Rejected</Badge>}
                  {n.is_verified == 1 && <Badge bg="success">Verified</Badge>}
                </td>
                <td>
                  <Button
                    size="sm"
                    variant="outline-info"
                    className="me-2"
                    as={Link}
                    to={`/users/${n.id}`} /* onClick={()=>handleView(n.id)} */
                  >
                    View
                  </Button>
                  <Button
                    size="sm"
                    variant="outline-secondary"
                    as={Link}
                    to={`/users/${n.id}/edit`}
                    className="me-2"
                  >
                    Edit
                  </Button>
                  <Button
                    size="sm"
                    variant="outline-danger"
                    onClick={() => handleDelete(n.id)}
                    className="me-2"
                  >
                    Delete
                  </Button>
                  {n.isBlocked ? (
                    <Button
                      className="me-2"
                      size="sm"
                      variant="outline-success"
                      onClick={() => handleUnblock(n)}
                    >
                      Unblock
                    </Button>
                  ) : (
                    <Button
                      className="me-2"
                      size="sm"
                      variant="outline-warning"
                      onClick={() => handleBlock(n)}
                    >
                      Block
                    </Button>
                  )}
                  {n.is_verified == 0 && (
                    <>
                      <Button
                        className="me-2"
                        size="sm"
                        variant="outline-success"
                        onClick={() => handleVerification(n)}
                      >
                        Verify user
                      </Button>
                      <Button
                        className="me-2"
                        size="sm"
                        variant="outline-danger"
                        onClick={() => handleReject(n)}
                      >
                        Reject verification
                      </Button>
                    </>
                  )}
                </td>
              </tr>
            ))}
            {items.length === 0 && (
              <tr>
                <td colSpan={6} className="text-center">
                  {loading ? "Loading..." : "No data"}
                </td>
              </tr>
            )}
          </tbody>
        </Table>
        <div className="d-flex justify-content-between align-items-center">
          <Form.Select
            style={{ maxWidth: 120 }}
            value={perPage}
            onChange={(e) => {
              setPerPage(parseInt(e.target.value, 10));
              setPage(1);
            }}
          >
            {[5, 10, 20, 50].map((n) => (
              <option key={n} value={n}>
                {n} / page
              </option>
            ))}
          </Form.Select>
          {/* <Pagination className="mb-0">
            <Pagination.Prev disabled={page<=1} onClick={()=>setPage(p=>Math.max(1,p-1))} />
            <Pagination.Item active>{page}</Pagination.Item>
            <Pagination.Next disabled={page>=totalPages} onClick={()=>setPage(p=>Math.min(totalPages,p+1))} />
          </Pagination> */}
          <Pagination className="mb-0">
            {/* Prev */}
            <Pagination.Prev
              disabled={page <= 1}
              onClick={() => setPage((p) => Math.max(1, p - 1))}
            />

            {/* Page numbers: previous */}
            {page > 1 && (
              <Pagination.Item onClick={() => setPage(page - 1)}>
                {page - 1}
              </Pagination.Item>
            )}

            {/* Active page */}
            <Pagination.Item active>{page}</Pagination.Item>

            {/* Page numbers: next */}
            {page < totalPages && (
              <Pagination.Item onClick={() => setPage(page + 1)}>
                {page + 1}
              </Pagination.Item>
            )}

            {/* Next */}
            <Pagination.Next
              disabled={page >= totalPages}
              onClick={() => setPage((p) => Math.min(totalPages, p + 1))}
            />
          </Pagination>
        </div>
      </Card.Body>
    </Card>
  );
}
